import LineBreakWrapper from "./Styles";

const LineBreak = ({ name }) => {
    return (
        <LineBreakWrapper>
            <h3>{name}</h3>
        </LineBreakWrapper>
    );
};

export default LineBreak;
